module.exports = __webpack_public_path__ + "img/active-resend-email.1be98651.svg";